// src/pages/user/Kyc.tsx

import Kyc from "../../components/user/Kyc";

export default function KycPage() {
  return <Kyc />;
};